module.exports = __webpack_public_path__ + "media/images/homes/restaurant-1327fff552a66050b52b10cd7f47e7ef.svg";